import React from 'react';
import {Row, Col, Table, message, Button, Modal, Spin, Card, Icon} from 'antd';
import moment from 'moment';
import {StyledPaymentCard} from './style';
import StripeForm from '../shop-pages/StripeForm';
import ApiService from '../../actions/apiService';
import {numberFormatter} from '../../utils/common'

class Payment extends React.Component {
  
  state = {
    history: [],
    token: '',
    isPaymentModalOpen: false,
    isLoading: true,
  }
  
  async componentWillMount() {
    await this.getData();
    await this.getPaymentHistory();
    this.setState({
      isLoading: false,
    })
  }
  
  getData = async () => {
    const response = await ApiService.getPayment();
    if (response) {
      this.setState({
        currentInfo: response,
      });
    }
  }
  
  getPaymentHistory = async () => {
    const response = await ApiService.getMethod('/subscription/history');
    if (response) {
      const history = (response || []).sort((a, b) => {
        if (moment(a.billingDate).isAfter(moment(b.billingDate))) {
          return -1;
        }
        return 1;
      });
      this.setState({
        history: response,
      });
    }
  }
  
  
  
  onToken = async (token) => {
    this.setState({
      token: token,
      isModalOpen: true,
    });
    
  }
  
  onSubmit = async () => {
    const {token} = this.state;
    const resp = await ApiService.submitStripeToken(token);
    if (resp) {
      message.success('You are successfully update information!');
      this.setState({
        isModalOpen: false,
        token: '',
      });
    }
    else {
      message.error('Something went wrong');
      this.setState({
        isModalOpen: false,
      });
    }
  }
  
  handleCancel = () => {
    this.setState({
      isModalOpen: false,
      isPaymentModal: false,
    })
  }
  
  onPaymentModal = () => {
    this.setState({
      isPaymentModal: true,
    })
  }
  
  render() {
    const columns = [
      {
        title: 'Date',
        dataIndex: 'billingDate',
        key: 'billingDate',
        render: (text) => { return  text ? moment(text).format('YYYY-MM-DD') : '--'}
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
      },
      {
        title: 'Amount',
        dataIndex: 'amount',
        key: 'amount',
        render: (text) => { return text ? `$${numberFormatter(text)}` : '--'},
      },
      {
        title: 'Download',
        dataIndex: 'invoicePdf',
        key: 'invoicePdf',
        render: (text) => { return text ? <a href={text} download><Icon type="download" /></a> : '--'},
      },
    ];
    
    const {currentInfo, history, isLoading} = this.state;
    if (isLoading) {
      return (
        <div style={{textAlign: 'center', marginTop: 50, width: '100%'}}>
          <Spin/>
        </div>
      );
    }
    return (
      <React.Fragment>
        <Row>
          <Col md={24} sm={24}>
            <Col md={8} sm={24}>
              <Card title="Current Payment Method">
                <Row>
                  <Col span={24}>
                    Current Card Number:
                  </Col>
                  <Col span={24}>
                    {(currentInfo && currentInfo.last4) ? '**** **** **** ' + currentInfo.last4 : ''}
                  </Col>
                </Row>
                
                <Row>
                  <Col span={24}>
                    <Button onClick={this.onPaymentModal} style={{marginTop: 10}}>Update Payment</Button>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Col>
        </Row>
        <Row>
            <Col md={24} sm={24} style={{marginTop: 100}}>
              <StyledPaymentCard title="Payment History">
                  <Table
                    columns={columns}
                    size={'small'}
                    dataSource={history}
                    onRow={(record) => {
                      return {
                        className: record.failed ? 'failed' : ''
                      };
                    }}
                    pagination={false}/>
              </StyledPaymentCard>
            </Col>
        </Row>
        <Modal
          visible={this.state.isModalOpen}
          title="Update Information."
          onCancel={this.handleCancel}
          footer={[
            <Button key="submit" type="primary" onClick={this.onSubmit}>
              Yes
            </Button>,
            <Button key="back" onClick={this.handleCancel}>No</Button>,
          ]}
        >
          Are you sure you want to update payment information?
        </Modal>
        <Modal
          visible={this.state.isPaymentModal}
          title="Update Information."
          onCancel={this.handleCancel}
          footer={[
            <Button key="back" onClick={this.handleCancel}>Cancel</Button>,
          ]}
        >
          <Row>
            <Col md={24} sm={24}>
                <StripeForm isUpdate={true} onToken={this.onToken} title="Update Payment Information" token={this.state.token} buttonText="Update Payment Information" />
            </Col>
          </Row>
        </Modal>
      </React.Fragment>
    );
  }
}

export default Payment



// WEBPACK FOOTER //
// ./src/components/user-profile/Payment.js